const Hobbie = (props) => {
  return (
    <div className="about-hobbies__hobbie">
      <img src={`/images/icons/${props.icon}`} alt={props.name} />
      <span>{props.name}</span>
    </div>
  );
};

export default Hobbie;
